import React from "react";
import Flag from "react-world-flags";

import moment from "moment";
import { CompetitionWrapperAFLW } from "../../components/layout/CompetionWrapperAFLW";
import { aflw } from "../../data/competitions/aflw-2021";
import * as numeral from 'numeral';
require('numeral/locales/en-gb');

numeral.locale('en-gb');
numeral.defaultFormat('$0,0');

const AFLWTeam = ({ aflwteam }) => (
  <CompetitionWrapperAFLW competition={aflw}>
    <div className="container clearfix mt-2">
      <div className="float-left">
        <h1>{aflwteam.name}</h1>
        <h5>Position 2022: {aflwteam.p2021}</h5>
	<h5>Coach: {aflwteam.coach}</h5>
      </div>
      <div className="container">
        <p />
      </div>
      <img
        className="rounded mx-auto d-block mb-3"
        align="right"
        src={`/img/aflw/logo/${aflwteam.pic}`}
        height={150}
      />
      <div className="float-right mr-2">
        <h5> Established {aflwteam.est}</h5>
      </div>
    </div>
    <div className="container">
      <p>{aflwteam.bio}</p>
      <p><u>Leadership Group</u><br/>Captain(s): {aflwteam.cap}<br/>
	Vice captain(s): {aflwteam.vc}<br/>
	Leadership Group: {aflwteam.lg}</p>
      <div className="row align-items-center">
        <div className="col-sm-6 order-sm-2">
          <div className="p-0">
            <img
              className="rounded mx-auto d-block mb-3"
              src={aflwteam.img1}
              width="450"
            />
          </div>
        </div>
        <div className="col-sm-6 order-sm-1">
          <div className="p-0">
            <img
              className="rounded mx-auto d-block mb-3"
              src={aflwteam.img2}
              width="450"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <p />
      <h5 align="right" >- - - - Fantasy Points - - - -</h5>
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col" align="center">
              Position
            </th>
            <th scope="col" align="center">
              Nationality
            </th>
            <th scope="col" align="center">Age</th>
            <th scope="col" align="center">Height</th>
            <th scope="col" align="center">Fantasy Price</th>
	    <th scope="col" align="center">2020</th>
	    <th scope="col" align="center">2021</th>
	    <th scope="col" align="center">2022</th>
	    <th scope="col" align="center">2023</th>
          </tr>
        </thead>
        <tbody>
          {aflwteam.ruck.map(
            ({
              name,
              pos,
              nat,
              price,
              dob,
	      h,
              no,
	      p17,
	      p18,
	      p21,
	      p20,
	      p22,
	      total,
	      club2020
            }) => (
              <tr key={name}>
                <td>{no}</td>
                <td>{name}</td>
                <td>{pos}</td>
                <td><img hspace="20" src={`/img/RoundFlags/${nat}.png`} width="40"/></td>
                <td>
                  {moment().diff(
                    moment(moment(dob, "DD-MM-YYYY")).format("MM-DD-YYYY"),
                    "years"
                  )}
                </td>
		<td>{h}</td>
                <td>{numeral(price).format()}</td>
		<td>{p20}</td>
		<td>{p21}</td>
		<td>{p22}</td>
		<td>{total}</td>
              </tr>
            )
          )}
          {aflwteam.def.map(
            ({
              name,
              pos,
              nat,
              price,
              dob,
              h,
              no,
              p17,
              p18,
              p21,
              p20,
              p22,
              total,
              club2020
            }) => (
              <tr key={name}>
                <td>{no}</td>
                <td>{name}</td>
                <td>{pos}</td>
                <td><img hspace="20" src={`/img/RoundFlags/${nat}.png`} width="40"/></td>
                <td>
                  {moment().diff(
                    moment(moment(dob, "DD-MM-YYYY")).format("MM-DD-YYYY"),
                    "years"
                  )}
                </td>
                <td>{h}</td>
                <td>{numeral(price).format()}</td>
                <td>{p20}</td>
                <td>{p21}</td>
                <td>{p22}</td>
                <td>{total}</td>
              </tr>
            )
          )}
          {aflwteam.mid.map(
            ({
              name,
              pos,
              nat,
              price,
              dob,
              h,
              no,
              p17,
              p18,
              p21,
              p20,
              p22,
              total,
              club2020
            }) => (
              <tr key={name}>
                <td>{no}</td>
                <td>{name}</td>
                <td>{pos}</td>
                <td><img hspace="20" src={`/img/RoundFlags/${nat}.png`} width="40"/></td>
                <td>
                  {moment().diff(
                    moment(moment(dob, "DD-MM-YYYY")).format("MM-DD-YYYY"),
                    "years"
                  )}
                </td>
                <td>{h}</td>
                <td>{numeral(price).format()}</td>
                <td>{p20}</td>
                <td>{p21}</td>
                <td>{p22}</td>
                <td>{total}</td>
              </tr>
            )
          )}
          {aflwteam.fwd.map(
            ({
              name,
              pos,
              nat,
              price,
              dob,
              h,
              no,
              p17,
              p18,
              p21,
              p20,
              p22,
              total,
              club2020
            }) => (
              <tr key={name}>
                <td>{no}</td>
                <td>{name}</td>
                <td>{pos}</td>
                <td><img hspace="20" src={`/img/RoundFlags/${nat}.png`} width="40"/></td>
                <td>
                  {moment().diff(
                    moment(moment(dob, "DD-MM-YYYY")).format("MM-DD-YYYY"),
                    "years"
                  )}
                </td>
                <td>{h}</td>
                <td>{numeral(price).format()}</td>
                <td>{p20}</td>
                <td>{p21}</td>
                <td>{p22}</td>
                <td>{total}</td>
              </tr>
            )
          )}
        </tbody>
	<thead className="thead-dark">
	<tr>
        <th scope="col" colspan="10"></th>
	<th scope="col"></th>
	</tr>
        </thead>
      </table>
    </div>

    <div className="container">
      <p />
    </div>
  </CompetitionWrapperAFLW>
);

export default AFLWTeam;
